import { z } from "zod";
import { macroGraphMessageSchema } from "./macroGraph";
import { systemMessageSchema } from "./system";
import { authMessageSchema } from "./auth";
import { connectionMessageSchema } from "./connection";
import { invitationMessageSchema } from "./invitation";
import { lobbyMessageSchema } from "./lobby";
import { metricsMessageSchema } from "./metrics";
import { peerMessageSchema } from "./peer";
import { presenceMessageSchema } from "./presence";
import { hostMessageSchema } from "./host";
import { hostGameSaveStorageMessageSchema } from "./gameSaveStorage";
import { outboundMessageSchema } from "./outbound";
import { profileMessageSchema } from "./profile";
import { matchmakingMessageSchema } from "./matchmaking";
import { userEventMessageSchema } from "./userEvents";
import { analyticsMessageSchema } from "./telemetryMessages";
import { notificationMessageSchema } from "./notification";
import { adminMessageSchema } from "./admin";
import { vpnMessageSchema } from "./vpn";
import { beaconMessageSchema } from "./beacon";
import { gamingScoreMessageUnion } from "./gamingScore";
import { provisioningMessageSchema } from "./provisioning";
import { macroBundleMessageSchema } from "./macroBundle";
import { macroPackageMessageSchema } from "./macroPackage";
import { macroAnalysisMessageSchema } from "./macroAnalysis";
import { liveOpsMessageUnion } from "./liveops";
import { userProfileMessageSchema } from "./userProfile";
import { notificationInboxMessageSchema } from "./notificationInbox";

// Combined message schema
type WebsocketMessageInput =
  | z.input<typeof macroGraphMessageSchema>
  | z.input<typeof systemMessageSchema>
  | z.input<typeof authMessageSchema>
  | z.input<typeof connectionMessageSchema>
  | z.input<typeof invitationMessageSchema>
  | z.input<typeof lobbyMessageSchema>
  | z.input<typeof metricsMessageSchema>
  | z.input<typeof peerMessageSchema>
  | z.input<typeof presenceMessageSchema>
  | z.input<typeof hostMessageSchema>
  | z.input<typeof hostGameSaveStorageMessageSchema>
  | z.input<typeof outboundMessageSchema>
  | z.input<typeof profileMessageSchema>
  | z.input<typeof matchmakingMessageSchema>
  | z.input<typeof userEventMessageSchema>
  | z.input<typeof analyticsMessageSchema>
  | z.input<typeof notificationMessageSchema>
  | z.input<typeof adminMessageSchema>
  | z.input<typeof vpnMessageSchema>
  | z.input<typeof beaconMessageSchema>
  | z.input<typeof gamingScoreMessageUnion>
  | z.input<typeof provisioningMessageSchema>
  | z.input<typeof macroBundleMessageSchema>
  | z.input<typeof macroPackageMessageSchema>
  | z.input<typeof macroAnalysisMessageSchema>
  | z.input<typeof liveOpsMessageUnion>
  | z.input<typeof userProfileMessageSchema>
  | z.input<typeof notificationInboxMessageSchema>;
type WebsocketSchemaOutput =
  | z.output<typeof macroGraphMessageSchema>
  | z.output<typeof systemMessageSchema>
  | z.output<typeof authMessageSchema>
  | z.output<typeof connectionMessageSchema>
  | z.output<typeof invitationMessageSchema>
  | z.output<typeof lobbyMessageSchema>
  | z.output<typeof metricsMessageSchema>
  | z.output<typeof peerMessageSchema>
  | z.output<typeof presenceMessageSchema>
  | z.output<typeof hostMessageSchema>
  | z.output<typeof hostGameSaveStorageMessageSchema>
  | z.output<typeof outboundMessageSchema>
  | z.output<typeof profileMessageSchema>
  | z.output<typeof matchmakingMessageSchema>
  | z.output<typeof userEventMessageSchema>
  | z.output<typeof analyticsMessageSchema>
  | z.output<typeof notificationMessageSchema>
  | z.output<typeof adminMessageSchema>
  | z.output<typeof vpnMessageSchema>
  | z.output<typeof beaconMessageSchema>
  | z.output<typeof gamingScoreMessageUnion>
  | z.output<typeof provisioningMessageSchema>
  | z.output<typeof macroBundleMessageSchema>
  | z.output<typeof macroPackageMessageSchema>
  | z.output<typeof macroAnalysisMessageSchema>
  | z.output<typeof liveOpsMessageUnion>
  | z.output<typeof userProfileMessageSchema>
  | z.output<typeof notificationInboxMessageSchema>;
export const hostWebsocketMessageSchema = z.union([hostMessageSchema, hostGameSaveStorageMessageSchema]);

export const websocketMessageSchema: z.ZodType<WebsocketSchemaOutput, z.ZodTypeDef, WebsocketMessageInput> = z.union([
  macroGraphMessageSchema,
  systemMessageSchema,
  authMessageSchema,
  connectionMessageSchema,
  invitationMessageSchema,
  lobbyMessageSchema,
  metricsMessageSchema,
  peerMessageSchema,
  presenceMessageSchema,
  hostWebsocketMessageSchema,
  outboundMessageSchema,
  profileMessageSchema,
  matchmakingMessageSchema,
  userEventMessageSchema,
  analyticsMessageSchema,
  notificationMessageSchema,
  adminMessageSchema,
  vpnMessageSchema,
  beaconMessageSchema,
  gamingScoreMessageUnion,
  provisioningMessageSchema,
  macroBundleMessageSchema,
  macroPackageMessageSchema,
  macroAnalysisMessageSchema,
  liveOpsMessageUnion,
  userProfileMessageSchema,
  notificationInboxMessageSchema,
]);
